document.addEventListener('click', (event) => {
  document.querySelectorAll('.fango-menu-dropdown[open], .fango-header .fango-localization[open]').forEach((panel) => {
    if (!panel.contains(event.target)) panel.open = false;
  });
});
(() => {
  let group;
  let header;
  let scroller;
  let observer;
  let lastY = 0;
  let travel = 0;
  let direction = 0;
  let headerHeight = 0;
  let frame = 0;
  const getY = () => Math.max(scroller?.scrollTop || 0, window.scrollY, document.scrollingElement?.scrollTop || 0);
  const reveal = () => group?.classList.remove('fango-header-hidden');
  function measure() {
    if (!header) return;
    const height = header.offsetHeight;
    document.body.style.setProperty('--header-height', height + 'px');
    document.body.style.setProperty('--header-group-height', height + 'px');
    document.querySelectorAll('.fango-menu-dropdown[open] .fango-menu-subpanel').forEach(fangoFitMenu);
  }
  function update() {
    frame = 0;
    if (!header || !group) return;
    const y = Math.max(0, getY());
    const delta = y - lastY;
    const nextDirection = Math.sign(delta);
    if (nextDirection !== direction) travel = 0;
    direction = nextDirection;
    travel += delta;
    lastY = y;
    const pinned = header.querySelector('details[open], :focus-visible');
    if (y < headerHeight || pinned || header.dataset.scrollHeader !== 'scroll-up' || window.Shopify?.designMode) {
      reveal();
      travel = 0;
    } else if (travel > 16) {
      group.classList.add('fango-header-hidden');
    } else if (travel < -8) {
      reveal();
    }
  }
  const onScroll = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  function init() {
    scroller?.removeEventListener('scroll', onScroll);
    observer?.disconnect();
    group = document.querySelector('#header-group');
    header = group?.querySelector('.fango-header');
    if (!header) return;
    scroller = document.querySelector('.page-wrapper');
    lastY = getY();
    direction = travel = 0;
    reveal();
    scroller?.addEventListener('scroll', onScroll, { passive: true });
    observer = new ResizeObserver(measure);
    observer.observe(header);
    measure();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', measure);
  document.addEventListener('focusin', (event) => {
    if (header?.contains(event.target)) reveal();
  });
  document.addEventListener('toggle', (event) => {
    if (header?.contains(event.target) && event.target.open) reveal();
  }, true);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', reveal);
  init();
})();
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const panels = Array.from(document.querySelectorAll('.fango-menu-dropdown[open], .fango-mobile-navigation[open], .fango-header .fango-localization[open]'));
  const active = panels.find((panel) => panel.contains(document.activeElement)) || panels[0];
  panels.forEach((panel) => { panel.open = false; });
  active?.querySelector('summary')?.focus();
});

function fangoFitMenu(panel) {
  if (!window.matchMedia('(min-width: 750px)').matches) { panel.style.maxHeight = ''; return; }
  panel.style.maxHeight = Math.max(180, window.innerHeight - panel.getBoundingClientRect().top - 16) + 'px';
}
document.addEventListener('toggle', (event) => {
  if (!event.target.matches?.('.fango-menu-dropdown') || !event.target.open) return;
  const panel = event.target.querySelector('.fango-menu-subpanel');
  if (panel) fangoFitMenu(panel);
}, true);
window.addEventListener('resize', () => {
  document.querySelectorAll('.fango-menu-dropdown[open] .fango-menu-subpanel').forEach(fangoFitMenu);
});

// Style only the existing widget UI; keep chat, consent and subscriptions native.
(() => {
 const css=":host{--forms-body-font:normal 400 14px Arial,Helvetica,sans-serif!important;--forms-heading-font:normal 400 26px Arial,Helvetica,sans-serif!important;--forms-accent-color:#111!important;--link-text-color:#111!important;--button-background-color:#111!important;--form-field-border-radius:0px!important;--button-border-radius:0px!important;--container-border-radius:0px!important;--container-shadow:none!important;--form-field-border:0 0 0 1px #777!important;--form-field-border-focused:0 0 0 2px #111!important;font-family:Arial,Helvetica,sans-serif!important}*,*::before,*::after{border-radius:0!important}*:not(svg):not(path){font-family:Arial,Helvetica,sans-serif!important}.activator{--activator-fg:#fff!important;--activator-bg:#111!important;background:#111!important;color:#fff!important;border:1px solid #111!important;box-shadow:none!important;letter-spacing:.055em;text-transform:uppercase!important}.panel{border:1px solid #111!important;box-shadow:none!important}.panel__header{border-bottom:1px solid #dedede!important}[data-testid=\"form-teaser\"]{background:#111!important;color:#fff!important;border:1px solid #111!important;box-shadow:none!important;letter-spacing:.055em}[data-testid=\"form-teaser\"] h3{color:#fff!important;font-size:12px!important;font-weight:400!important}[data-testid=\"form-teaser\"] [role=\"button\"]{background:#111!important;color:#fff!important}[data-testid=\"form-teaser\"] svg{fill:currentColor!important}button[type=\"submit\"]{background:#111!important;color:#fff!important;border:1px solid #111!important;min-height:46px!important;letter-spacing:.055em;text-transform:uppercase!important}input,textarea,select{font-size:16px!important}button:focus-visible,a:focus-visible,input:focus-visible{outline:2px solid #111;outline-offset:3px}";
 const submitCss="button[data-testid=\"btn-form-submit\"]{box-sizing:border-box!important;display:flex!important;align-items:center!important;justify-content:center!important;height:48px!important;min-height:48px!important;padding:12px 20px!important;line-height:20px!important;font-size:14px!important;flex:0 0 auto!important;text-align:center!important}";
 const watched=new WeakSet();
 const tags='shopify-chat,shopify-agent-runtime,shopify-forms-embed';
 function visit(root){
  if(!watched.has(root)){
   watched.add(root);
   new MutationObserver(records=>{
    for(const record of records)for(const node of record.addedNodes){
     if(node instanceof Element)scan(node,root!==document);
    }
   }).observe(root,{childList:true,subtree:true});
  }
  scan(root,root!==document);
 }
 function scan(root,nested){
  const hosts=[];
  if(root instanceof Element)hosts.push(root);
  hosts.push(...root.querySelectorAll(nested?'*':tags));
  for(const host of hosts){
   const shadow=host.shadowRoot;
   if(!shadow||watched.has(shadow))continue;
   if(!shadow.querySelector('style[data-fango-widget]')){const style=document.createElement('style');style.dataset.fangoWidget='';style.textContent=css+submitCss+".activator,[data-testid=\"form-teaser\"]{box-sizing:border-box!important;height:48px!important;min-height:48px!important;max-height:48px!important;margin:0!important;display:flex!important;align-items:center!important;padding-block:0!important}.activator{bottom:max(16px,env(safe-area-inset-bottom))!important}[data-testid=\"form-teaser\"]{position:fixed!important;bottom:max(16px,env(safe-area-inset-bottom))!important;left:16px!important;right:auto!important;top:auto!important}[data-testid=\"form-teaser\"] h3{margin:0!important;line-height:1.2!important}";style.textContent += '@media(max-width:749px){.activator{visibility:var(--fango-assistance-visibility,visible)!important;pointer-events:var(--fango-assistance-events,auto)!important}[data-testid="form-teaser"]{visibility:var(--fango-newsletter-visibility,hidden)!important;pointer-events:var(--fango-newsletter-events,none)!important}}';shadow.append(style);}
   visit(shadow);
  }
 }
 visit(document);
 for(const tag of tags.split(',')){customElements.whenDefined(tag).then(()=>scan(document,false));}
})();

// Keep Stand Up badges below the price; inspect only newly inserted badge subtrees.
(() => {
 const selector='product-card .deco-collection-below-image img,product-card .deco-collection-below-title img';
 const pending=new Set();
 let frame=0;
 function collect(root){
  if(!(root instanceof Element||root instanceof Document))return;
  const images=root instanceof Element&&root.matches(selector)?[root]:[];
  images.push(...root.querySelectorAll(selector));
  for(const image of images)if(/stand[\s_-]*up/i.test(image.alt))pending.add(image);
  if(pending.size&&!frame)frame=requestAnimationFrame(position);
 }
 function position(){
  frame=0;
  for(const image of pending){
   if(!image.isConnected)continue;
   const badge=image.closest('.pl-badge-image');
   const card=image.closest('product-card');
   const price=card?.querySelector('product-price');
   if(!badge||!price)continue;
   let slot=card.querySelector('.fango-standup-slot');
   if(!slot){slot=document.createElement('div');slot.className='fango-standup-slot';price.after(slot);}
   const id=badge.dataset.badgeId;
   if(id&&Array.from(slot.children).some(item=>item!==badge&&item.dataset.badgeId===id)){badge.remove();continue;}
   if(badge.parentElement!==slot)slot.append(badge);
  }
  pending.clear();
 }
 new MutationObserver(records=>{
  for(const record of records){
   if(record.type==='attributes')collect(record.target);
   else for(const node of record.addedNodes)collect(node);
  }
 }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['alt']});
 collect(document);
})();

/* Follow the visible edge of the scroll-away header with collection filters. */
(()=>{let frame=0,until=0,lastBottom=-1;function measure(){const header=document.querySelector('.fango-header');const bottom=header?Math.max(0,header.getBoundingClientRect().bottom):0;if(bottom!==lastBottom){document.body.style.setProperty('--fango-filter-top',bottom+'px');lastBottom=bottom;}if(performance.now()<until)frame=requestAnimationFrame(measure);else frame=0;}function update(){until=performance.now()+350;if(!frame)frame=requestAnimationFrame(measure);}document.addEventListener('scroll',update,{passive:true,capture:true});window.addEventListener('resize',update);document.addEventListener('shopify:section:load',update);update();})();

/* Keep chat clear of purchase controls; unrelated app mutations must not force layout. */
(()=>{
 const selector='button[name="add"],button[name="checkout"],shopify-accelerated-checkout,.sticky-add-to-cart';
 const controls=new Set();
 let pending=false;
 function collect(root){
  if(!(root instanceof Element||root instanceof Document))return false;
  let changed=false;
  const found=root instanceof Element&&root.matches(selector)?[root]:[];
  found.push(...root.querySelectorAll(selector));
  for(const control of found){if(!controls.has(control)){controls.add(control);changed=true;}}
  return changed;
 }
 function update(){
  pending=false;
  const width=innerWidth,height=innerHeight;
  let overlaps=false;
  for(const el of controls){
   if(!el.isConnected){controls.delete(el);continue;}
   const r=el.getBoundingClientRect();
   if(r.width>0&&r.height>0&&r.right>width-145&&r.left<width&&r.top<height-12&&r.bottom>height-105){overlaps=true;break;}
  }
  document.body.classList.toggle('fango-purchase-in-chat-corner',overlaps);
 }
 function schedule(){if(!pending){pending=true;requestAnimationFrame(update);}}
 collect(document);
 document.addEventListener('scroll',()=>{if(controls.size)schedule();},{passive:true,capture:true});
 window.addEventListener('resize',schedule);
 document.addEventListener('shopify:section:load',event=>{collect(event.target);schedule();});
 new MutationObserver(records=>{
  let changed=false;
  for(const record of records){
   for(const node of record.addedNodes)changed=collect(node)||changed;
   if(record.removedNodes.length){for(const control of controls){if(!control.isConnected){controls.delete(control);changed=true;}}}
  }
  if(changed)schedule();
 }).observe(document.body,{childList:true,subtree:true});
 schedule();
})();
